import { render, staticRenderFns } from "./PigeonLogo.vue?vue&type=template&id=47d38407&scoped=true&"
import script from "./PigeonLogo.vue?vue&type=script&lang=ts&"
export * from "./PigeonLogo.vue?vue&type=script&lang=ts&"
import style0 from "./PigeonLogo.vue?vue&type=style&index=0&id=47d38407&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d38407",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
